// Admin paneli ortak arama yardımcıları.
// Türkçe duyarsız: "traktor" → "Traktör", "inek" → "İnek", "isik" → "IŞIK" eşleşir.
export const normalizeSearch = value =>
  String(value ?? "")
    .toLocaleLowerCase("tr")
    .replace(/ı/g, "i")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim();

const MAX_DEPTH = 2;
const collectText = (value, depth, out) => {
  if (value == null) return;
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    out.push(String(value));
    return;
  }
  if (depth >= MAX_DEPTH || typeof value !== "object") return;
  if (Array.isArray(value)) {
    value.slice(0, 50).forEach(v => collectText(v, depth + 1, out));
    return;
  }
  Object.keys(value).forEach(k => collectText(value[k], depth + 1, out));
};

// Kaydın tüm alanları ($expand ile gelen iç içe nesneler dahil) tek metin olarak;
// kayıt nesnesi başına bir kez hesaplanır.
const textCache = new WeakMap();
export const getSearchText = record => {
  if (record == null || typeof record !== "object") return normalizeSearch(record);
  let text = textCache.get(record);
  if (text === undefined) {
    const parts = [];
    collectText(record, 0, parts);
    text = normalizeSearch(parts.join(" "));
    textCache.set(record, text);
  }
  return text;
};

// Sorgudaki TÜM kelimeler geçmeli (ör. "ahmet traktör").
// `fields` verilirse yalnız o değerlerde, verilmezse kaydın tamamında aranır.
export const matchesSearch = (record, query, fields) => {
  const terms = normalizeSearch(query).split(/\s+/).filter(Boolean);
  if (terms.length === 0) return true;
  const text = fields
    ? normalizeSearch(fields.filter(v => v != null).join(" "))
    : getSearchText(record);
  return terms.every(t => text.includes(t));
};
